export default {"src":"/_next/static/media/logo_chippu.e06eb1e9.svg","height":28,"width":86,"blurWidth":0,"blurHeight":0};